<template>
  <div class="row justify-center q-pb-md q-pt-xs">
    <div class="full-width width-custom q-px-md">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFooterFrame'
}
</script>
